{
    "TelnosmovedtoLabel": "Telefoonnummer(s) Verplaatst naar:",
    "DevicesmovedfromLabel": "Toestel(en) verplaatst van:",
    "AcdagentsmovedfromLabel": "ACD-agent(en) verplaatst van:",
    "CallsegmentnumberLabel": "Oproepsegmentnummer:",
    "CallsegmentnumberAnyOptionLabel": "[Any]",
    "CallsegmentnumberFirstOptionLabel": "[Eerst]",
    "Callsegmentnumber2OptionLabel": "2",
    "Callsegmentnumber3OptionLabel": "3",
    "Callsegmentnumber4OptionLabel": "4",
    "Callsegmentnumber5OptionLabel": "5",
    "Callsegmentnumber6plusOptionLabel": "6+",
    "CallsegmentnumberLastOptionLabel": "[Laatst]",
    "CallsegmentstartreasonLabel": "Reden voor start van het oproepsegment:",
    "CallsegmentstartreasonAnyOptionLabel": "[Any]",
    "CallsegmentstartreasonDivertedtoOptionLabel": "Omgeleid naar",
    "CallsegmentstartreasonOverflowedinOptionLabel": "Overstroomd",
    "CallsegmentstartreasonAdvancedtoOptionLabel": "Geavanceerd",
    "CallsegmentstartreasonTransferredtoOptionLabel": "Overgeplaatst naar",
    "CallsegmentstartreasonConferencedtoOptionLabel": "Geconfereerd aan",
    "CallsegmentstartreasonConferencedegenOptionLabel": "Conferentie De\/Gen",
    "CallsegmentendreasonLabel": "Reden voor einde gesprekssegment:",
    "CallsegmentendreasonAnyOptionLabel": "[Any]",
    "CallsegmentendreasonDivertedfromOptionLabel": "Omgeleid van",
    "CallsegmentendreasonOverflowedoffOptionLabel": "Overgelopen uit",
    "CallsegmentendreasonAdvancedfromOptionLabel": "Geavanceerd Van",
    "CallsegmentendreasonTransferredfromOptionLabel": "Overgedragen van",
    "CallsegmentendreasonConferencedfromOptionLabel": "Vergader vanaf",
    "CallsegmentendreasonConferencedegenOptionLabel": "Conferentie De\/Gen",
    "CallsegmentendreasonConsultationtrtoOptionLabel": "Overleg Tr\/To",
    "CallsegmentendreasonMovedtoconferenceOptionLabel": "Verplaatst naar conferentie",
    "CallsegmentendreasonMovedtoparkOptionLabel": "Verplaatst naar park",
    "CallsegmentendreasonMovedtovoicemailOptionLabel": "Verplaatst naar voicemail",
    "CallsegmentendreasonEndedonholdonlyOptionLabel": "Alleen in wachtstand beëindigd",
    "CallsegmentendreasonEndedonholdexclOptionLabel": "Beëindigd In de wacht Uitgesloten",
    "CallsegmentendreasonUnmonitoreddestOptionLabel": "Niet-gecontroleerde bestemming",
    "CallsegmentendreasonUnknowndestOptionLabel": "Onbekende bestemming",
    "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Alleen alle onopgeloste bestemmingen",
    "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Alle onopgeloste bestemmingen uitgesloten",
    "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Bevestig dat alles correct is getypt en ga dan verder met het importeren van het voltooide bestand hier (Eventuele fouten met het bestand worden opgemerkt tijdens de configuratie):",
    "CallsegmentendreasonModellingerrorsexclOptionLabel": "Bevestig dat alles correct is getypt en ga dan verder met het importeren van het voltooide bestand hier (Eventuele fouten met het bestand worden opgemerkt tijdens de configuratie):",
    "CallsegmentendreasonApplicationendedOptionLabel": "Aanvraag beëindigd",
    "CallsegmentendreasonDevicedeletedOptionLabel": "Apparaat verwijderd",
    "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "Geen antwoord nodig E-mails uitgesloten",
    "CallsegmentchainidLabel": "Oproepsegmentketen-ID (applicatie-oproep-ID):",
    "CallMovementFiltering_SectionHeader": "Oproepbewegingsfiltering",
    "CallMovementFiltering_AnyPlaceholder": "[Any]",
    "NAME": "CallMovementFiltering",
    "AcdagentsmovedfromLabel_MST": "Agent(en) Verhuisd van:",
    "CallsegmentstartreasonEscapedtoOptionLabel": "Ontsnapt naar",
    "CallsegmentendreasonEscapedfromOptionLabel": "Ontsnapt",
    "CallsegmentnumberFirstAfterFilteringOptionLabel": "[Eerste - Na filtering]",
    "CallsegmentnumberLastAfterFilteringOptionLabel": "[Laatste - Na filtering]",
    "CallsegmentStartEndReasonSupervisorTransferOptionLabel": "Overdracht van supervisor"
}